import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

// Same support number as the "Suporte" item of the sidebar.
const SUPPORT_WHATSAPP_NUMBER = '5548991094459';

// Friendly notice shown when the clinic's plan doesn't include a feature.
// React 19 ignores defaultProps on function components, so the default lives in the signature.
function PlanUpgradeDialog({ open, onClose, feature, requiredPlan = 'PLUS' }) {
  const openSupportWhatsApp = () => {
    const message = encodeURIComponent(
      `Gostaria de alterar meu plano para o plano ${requiredPlan}`,
    );
    window.open(`https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WorkspacePremiumOutlinedIcon color="primary" />
        Recurso do plano {requiredPlan}
      </DialogTitle>
      <DialogContent dividers>
        <Typography sx={{ mb: 1.5 }}>
          {feature} está disponível a partir do plano <strong>{requiredPlan}</strong>.
        </Typography>
        <Typography color="text.secondary">
          Entre em contato com o nosso suporte para alterar o seu plano e liberar esta
          funcionalidade.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Entendi</Button>
        <Button
          variant="contained"
          color="success"
          startIcon={<WhatsAppIcon />}
          onClick={openSupportWhatsApp}
        >
          Falar com o suporte
        </Button>
      </DialogActions>
    </Dialog>
  );
}

PlanUpgradeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  feature: PropTypes.string.isRequired,
  requiredPlan: PropTypes.string,
};

export default PlanUpgradeDialog;
